import workspaceQuery from 'graphql/queries/product/ProductsBinLocationWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/product/ProductsBinLocationWarehouseListQuery.graphql';
import instanceQuery from 'graphql/queries/product/ProductsBinLocationQuery.graphql';
import defaultQuery from 'graphql/queries/product/ProductsBinLocationDefault.graphql';
import mutationQuery from 'graphql/mutations/product/ProductsBinLocationMutation.graphql';
import rangeMutationQuery from 'graphql/mutations/product/ProductsBinLocationRangeMutation.graphql';
import fragment from 'graphql/fragments/product/ProductsBinLocationFragment.graphql';
import { Direction } from '../../schema/p4types';

const ProductsBinLocation: EntityType = {
  type: 'BinLocation',
  title: 'Bin Locations',
  formTitle: 'Bin Location',
  formUrl: '/Products/StockControl/BinLocation/Details/',
  workspaceUrl: '/Products/StockControl/BinLocation/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  updateRange: rangeMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'location',
    rawLabel: true,
    remoteFilter: true,
    preLoad: true,
    customVariables: () => {
      return {
        orderBy: 'location',
        orderDirection: Direction.Asc,
        first: 50,
      };
    },
  },
  fragment,
  screenReference: 'PRODUCTS_STOCK_CONTROL_BIN_LOCATIONS',
};

export default ProductsBinLocation;
